import {AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {QuestionInput} from '../question-input';
import {MatDatepicker, MatDatepickerIntl} from "@angular/material";

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent extends QuestionInput implements AfterViewInit, OnInit {


  @ViewChild('inputField', {static: true})

  inputField: ElementRef;
  dateValue: Date;

  placeholder = 'Choose a date';
  pointerNone  = 'pointer-none-date';

  constructor(private _intl: MatDatepickerIntl,) {
    super();
  }

  ngOnInit(): void {
    if (this.question.answer && this.question.answer && /^\d{2}\/\d{2}\/\d{4}$/.exec(this.question.answer)) {
      this.dateValue = new Date(this.question.answer);
    }
    if(this.question.questionTitle == 'Next appointment '){
      this.placeholder += ' or type NONE';
      this.pointerNone = 'pointer-date';
    }
  }
  ngAfterViewInit(): void {


    setTimeout(() => {
      this.questionAnswered.emit(this.question.answer != null);
    });
  }

  valueChange(value) {
    this.questionAnswered.emit(!!value);
  }


  get answer(): any {
    return (this.inputField.nativeElement as HTMLInputElement).value;
  }

  getMaxDate() {
    const currentDate = new Date();
    return new Date(currentDate.getFullYear() + 1, 11, 31);
  }
}
